import { render, staticRenderFns } from "./DeleteTeamModal.vue?vue&type=template&id=5d35b144&scoped=true"
import script from "./DeleteTeamModal.vue?vue&type=script&lang=js"
export * from "./DeleteTeamModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteTeamModal.vue?vue&type=style&index=0&id=5d35b144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d35b144",
  null
  
)

export default component.exports